<life-di-nav></life-di-nav>

<div class="container-fulid text-center overflow-hidden" style="padding-top: 50px;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h2>
        กรุณากรอกอีเมล
      </h2>
      <form [formGroup]="forgetPasswordForm">
        <div class="form-group row row justify-content-center">
          <div class="col-md-6">
            <input type="email" class="form-control" id="email" formControlName="email">
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div *ngIf="this.errorMsg !== null">
              <span class="text-danger">{{errorMsg}}</span>
            </div>
            <lifedi-btn lable="รีเซ็ตรหัสผ่าน" *ngIf="forgetPasswordForm.valid"
              customStyle="color:white; background-color: #414A6B; width: 100%;" (click)="resetPassword()"></lifedi-btn>
            <lifedi-btn lable="รีเซ็ตรหัสผ่าน" *ngIf="!forgetPasswordForm.valid" customStyle="width: 100%;"
              [disabled]="true">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>
  </div>
